import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import BankAccount from './BankAccount';

@NeoModel
export default class BankAccountBalance extends ModelBase {
    static typeName = "BankAccountBalance";

    public bankAccountBalanceId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public balanceDate: Date | null = null;

    @Attributes.Float()
    public balance: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public bankAccountId: number | null = null;

    @Attributes.Parent(() => BankAccount)
    public bankAccount: BankAccount | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New bank account balance";
        } else {
            return "Bank Account Balance";
        }
    }
}